import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  coverImage: string;
  category: string;
  categorySlug: string;
  createdAt: string;
  readTime: string;
  tags: string[];
}

export default function ArticleCard({
  slug,
  title,
  excerpt,
  coverImage,
  category,
  categorySlug,
  createdAt,
  readTime,
  tags,
}: ArticleCardProps) {
  return (
    <article className="bg-background-50 rounded-lg border border-background-200/60 overflow-hidden group cursor-pointer transition-colors hover:border-background-300/60">
      <Link to={`/article/${slug}`} className="block">
        <div className="aspect-[16/9] overflow-hidden">
          <img
            src={coverImage}
            alt={title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
          />
        </div>
      </Link>
      <div className="p-4 md:p-5">
        <div className="flex items-center gap-3 mb-3">
          <Link
            to={`/category/${categorySlug}`}
            className="text-xs px-2 py-1 rounded-full bg-secondary-100 text-secondary-900 whitespace-nowrap cursor-pointer hover:bg-secondary-200 transition-colors"
          >
            {category}
          </Link>
          <span className="text-xs text-foreground-500">{createdAt}</span>
          <span className="text-xs text-foreground-500">{readTime}</span>
        </div>
        <Link to={`/article/${slug}`} className="block">
          <h3 className="text-base font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
            {title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
          {excerpt}
        </p>
        <div className="flex flex-wrap gap-1">
          {tags.slice(0, 3).map((tag) => (
            <span key={tag} className="text-xs text-foreground-400">
              #{tag}
            </span>
          ))}
        </div>
      </div>
    </article>
  );
}